module.exports = __webpack_public_path__ + "media/packs/images/arrow-fe074a320fbcd47c3fe6b72f44894f96.svg";